export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_20.6adc38d8.jpg";